// extracted by mini-css-extract-plugin
module.exports = {"refund-dialog":"refund-dialog-0f0f8ffbc99a863a4f1f4760447f512b"};